import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocalization } from '~/framework';
import { useApiErrorMessageToast } from '~/pages/_shared';
import { saveWikiFromClient } from '~/pages/api/wikis/saveWiki.api';
import { WikiNamespaces } from '~/monolith-api';
import { getWikiKey } from '~/pages/_shared/useWiki';

type UseSaveWikiOptions = {
   onSuccess?: () => void;
};

export function useSaveWiki(
   namespace: WikiNamespaces,
   title: string,
   revisionid: number | null,
   options: UseSaveWikiOptions = {}
) {
   const { _js } = useLocalization();
   const queryClient = useQueryClient();

   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast({
      default: _js('There was an error saving the wiki, please try again.'),
   });

   return useMutation({
      mutationFn: async (fields: {
         major_approval_processid?: number | null;
         minor_approval_processid?: number | null;
         default_child_major_approval_processid?: number | null;
         default_child_minor_approval_processid?: number | null;
      }) => {
         if (!revisionid) {
            throw new Error('Revision ID is required');
         }
         return await saveWikiFromClient(namespace, title, revisionid, fields);
      },
      onError: handleErrorOrRedirectToLogin,
      onSuccess: () => {
         queryClient.invalidateQueries({ queryKey: getWikiKey(namespace, title) });
         options.onSuccess?.();
      },
   });
}
